export const jsonToFile = (jsonData: any, filename = 'data') => {
  // Convert JSON object to string
  const jsonString = JSON.stringify(jsonData, null, 2);

  // Create a Blob from the JSON string
  const blob = new Blob([jsonString], { type: 'application/json' });

  // Create a file from the Blob (optional)
  const file = new File([blob], `${filename}.json`, { type: 'application/json' });

  return file;
};
